import { useTrackers } from '@ps/web-shared-analytics';
import type React from 'react';
import { useContext, useEffect, useRef } from 'react';

import { AnalyticsContext } from '@swf/core/providers/AnalyticsProvider';

interface Props {
  seen: boolean;
  name: string;
}

const Tracker: React.FC<Props> = ({ seen, name }) => {
  const { initialized: GAInitialized } = useContext(AnalyticsContext);
  const { widgetViewed } = useTrackers();
  const previouslySeen = useRef(false);

  useEffect(() => {
    if (GAInitialized && seen && !previouslySeen.current) {
      previouslySeen.current = seen;
      widgetViewed(name);
    }
  }, [GAInitialized, seen, name, widgetViewed]);

  return null;
};

export default Tracker;
